<template>
  <v-container fluid>
    <v-row no-gutters class="mb-4">
      <v-col cols="12">
        <v-row justify="end">
          <v-btn class="mr-4" color="grey lighten-1" :to="{ name: 'ConstructionMasterDetail', params: { id: constructionId } }" depressed>戻る</v-btn>
        </v-row>
      </v-col>
    </v-row>
    <!-- メイン -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-row no-gutters>
            <v-col cols="12">
              <v-chip class="mr-2" color="accent" outlined label pill>
                <strong class="mr-2">工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ totalAchievementPrice }} / {{ totalBudgetPrice }} ({{ totalRate }}%)
              </v-chip>
              <v-divider/>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <!-- 工種選択 -->
            <v-col cols="12" md="3">
              <custom-tree-view :elevation="0" :title="treeTitle" :items="treeItems" @onSelected="onSelected" :visibleTemplate="false"
                :visibleFolderAdd="false" :visibleFileAdd="false" :visibleUnSelected="false" :visibleEdit="false" :visibleDelete="false" :visibleCopy="false" :visibleReflect="false"/>
            </v-col>
            <!-- 工種表示 -->
            <v-col cols="12" md="9">
              <custom-data-table :elevation="0" :tableName="tableName" :header="headers" :items="items" :loading="loading" :visibleStore="false">
                <template v-slot:custom>
                  <v-chip color="accent" outlined label pill>
                    <strong class="mr-2">選択工事原価</strong><v-icon small left>mdi-currency-jpy</v-icon>{{ achievementPrice }} / {{ budgetPrice }} ({{ rate }}%)
                  </v-chip>
                  <v-divider/>
                </template>
              </custom-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import AchievementApi from "@/api/achievement-api"
  import CustomTreeView from '@/components/custom_ui/CustomTreeView';
  import CustomDataTable from "@/components/custom_ui/CustomDataTable";
  import CalcCommon from "@/helpers/calcCommon";

  export default {
    name: "AchievementInfo",
    components: {
      CustomTreeView,
      CustomDataTable
    },
    data: () => ({
      loading: false,
      // 金額系
      totalBudgetPrice: 0,
      budgetPrice: 0,
      totalAchievementPrice: 0,
      achievementPrice: 0,
      totalRate: 0,
      rate: 0,
      // 工種選択
      treeTitle: "工種",
      treeItems: [],
      selectedNode: null,
      // 工種表示
      tableName: "選択項目",
      headers: [
          { text: "No.", value: "no" },
          { text: "費目", value: "expense" },
          { text: "規格等", value: "standard" },
          { text: "数量", value: "amount", align: 'end' },
          { text: "単位", value: "displayUnit" },
          { text: "単価", value: "unitPrice", align: 'end' },
          { text: "金額(税抜)", value: "price", align: 'end' },
          { text: "集計費目", value: "aggregateName" }
      ],
      items: [],
      constructionId: null,
      budgetId: null,
      achievementTable: null,
      percentage_flg: true,
      aggregateList: []
    }),
    created() {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize() {
        this.isLoading();
        this.achievementApi = new AchievementApi();
        this.constructionId = this.$route.params.id
        this.budgetId = this.$route.params.budget
        const promise = this.achievementApi.info(this.constructionId, this.budgetId);
        promise.then(response => {
            this.achievementTable = response.data.body.construction_daily_report_info;
            this.aggregateList = response.data.body.aggregate_list;
            this.percentage_flg = response.data.body.percentage_flg.percentage_flg;
            if (response.data.body.budget_info.tree_data) {
                this.treeItems = response.data.body.budget_info.tree_data.row;
                this.initializeAchievementData();
                this.calcTotalPrice();
            }
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // 工種選択
      onSelected(node) {
        this.selectedNode = node;
        this.tableName = node.data.text;
        this.items = node.data.items ? node.data.items : [];

        this.calcTotalPrice();
        for (var item of this.items) {
          item.unitPrice = CalcCommon.addFigure(item.unitPrice);
          item.taxPrice = CalcCommon.addFigure(item.taxPrice);

          // 実績値 / 実行予算値 (進捗率)
          item.amount = CalcCommon.addFigure(item.achievementAmount) + " / " + CalcCommon.addFigure(item.budgetAmount);
          item.amount += " (" + CalcCommon.orgRound(item.achievementAmount / (item.budgetAmount == 0 ? 1 : item.budgetAmount) * 100, 10) + "%)";
          item.price = CalcCommon.addFigure(item.achievementPrice) + " / " + CalcCommon.addFigure(item.budgetPrice);
          item.price += " (" + CalcCommon.orgRound(item.achievementPrice / (item.budgetPrice == 0 ? 1 : item.budgetPrice) * 100, 10) + "%)";
        }
      },
      // 工事原価・選択工事原価 計算
      calcTotalPrice() {
        // 工事原価
        if (this.treeItems) {
          this.totalBudgetPrice = 0;
          this.totalAchievementPrice = 0;
          for (var item of this.treeItems) {
            this.totalBudgetPrice += this.reduceBudgetPrice(item);
            this.totalAchievementPrice += this.reduceAchievementPrice(item);
          }
          // 進捗率は小数点第二位を四捨五入する。
          this.totalRate = CalcCommon.orgRound(this.totalAchievementPrice / (this.totalBudgetPrice == 0 ? 1 : this.totalBudgetPrice) * 100, 10);

          this.totalBudgetPrice = CalcCommon.addFigure(this.totalBudgetPrice);
          this.totalAchievementPrice = CalcCommon.addFigure(this.totalAchievementPrice);
        }
        // 選択工事原価
        if (this.selectedNode) {
          this.budgetPrice = this.reduceBudgetPrice(this.selectedNode);
          this.achievementPrice = this.reduceAchievementPrice(this.selectedNode);
          this.rate = CalcCommon.orgRound(this.achievementPrice / (this.budgetPrice == 0 ? 1 : this.budgetPrice) * 100, 10);
          this.budgetPrice = CalcCommon.addFigure(this.budgetPrice);
          this.achievementPrice = CalcCommon.addFigure(this.achievementPrice);
        } else {
          this.budgetPrice = 0;
          this.achievementPrice = 0;
        }
      },
      // 実行予算用
      reduceBudgetPrice(object) {
        var price = 0;
        if (object.children.length > 0) {
          for (var child of object.children) {
            price += this.reduceBudgetPrice(child);
          }
        }
        if (object.data.items.length > 0) {
          // (数量 * 歩掛) * 単価
          for (var item of object.data.items) {
            var tmp = item.budgetAmount;
            if (this.percentage_flg) {
              // (数量 * 歩掛) 小数点以下第２位四捨五入
              tmp = item.multipl;
            }
            // (数量 * 歩掛) * 単価 小数点以下第1位切り上げ
            tmp = tmp * CalcCommon.disFigure(item.unitPrice);
            tmp = CalcCommon.orgCeil(tmp, 1);
            price += tmp;
          }
        }
        return price;
      },
      // 実績用
      reduceAchievementPrice(object) {
        var price = 0;
        if (object.children.length > 0) {
          for (var child of object.children) {
            price += this.reduceAchievementPrice(child);
          }
        }
        if (object.data.items.length > 0) {
          for (var item of object.data.items) {
            price += item.achievementPrice;
          }
        }
        return price;
      },
      // 実績情報初期化
      initializeAchievementData() {
        // 実績値が使用されたか判定するフラグを追加する
        for(let achievementRow of this.achievementTable) {
          for(let aggregate of this.aggregateList) {
            if(aggregate.aggregate_flg || !achievementRow.report.expenseTableData[aggregate.name]) {
              continue;
            }
            for(let achievement of achievementRow.report.expenseTableData[aggregate.name]) {
              achievement.hasUsed = false;
            }
          }
        }

        if(this.treeItems) {
          for(let item of this.treeItems) {
            this.setAchievementData(item);
          }

          this.addNotExistsAchievementData();
        }
      },
      // 実績値取得処理
      setAchievementData(node) {
        if(node.children.length > 0) {
          for(let child of node.children) {
            this.setAchievementData(child);
          }
        }

        let items = node.data.items;
        for(let item of items) {
          item.budgetPrice = item.price;
          item.budgetAmount = item.amount;
          item.achievementPrice = 0;
          item.achievementAmount = 0;

          for(let achievementRow of this.achievementTable) {
            if(node.text != achievementRow.report.tabName) {
              continue;
            }
            let achievementList = this.findAchievementList(achievementRow, item);
            if(achievementList == null) {
              continue;
            }
            for(let achievementInfo of achievementList) {
              if(item.aggregate.flg) {
                // 金額
                if(achievementInfo.workPrice) {
                  item.achievementPrice += achievementInfo.workPrice;
                }
                // 数量
                item.achievementAmount++;
              } else {
                // 金額
                if(achievementInfo.price) {
                  item.achievementPrice += achievementInfo.price;
                }
                // 数量
                if(achievementInfo.achievement) {
                  item.achievementAmount += parseInt(achievementInfo.achievement);
                }
              }
            }
          }
        }
      },
      // 実行予算と紐付く実績情報を取得する。
      findAchievementList(achievementRow, item) {
        let achievement = [];
        if(item.aggregate.flg) {
          achievement = achievementRow.report.employmentCostDataTable;
        } else if(achievementRow.report.expenseTableData[item.aggregateName]) {
          achievement = achievementRow.report.expenseTableData[item.aggregateName];
        }

        // 複数ある場合に対応するため、配列で返す
        let achievementList = [];
        for(let achievementInfo of achievement) {
          if(item.id && achievementInfo.id) {
            if(item.id == achievementInfo.id) {
              achievementInfo.hasUsed = true;
              achievementList.push(achievementInfo);
            }
          } else if(item.expense == achievementInfo.expense) {
            achievementInfo.hasUsed = true;
            achievementList.push(achievementInfo);
          } else if(item.expense == achievementInfo.workName) {
            achievementInfo.hasUsed = true;
            achievementList.push(achievementInfo);
          }
        }
        return achievementList;
      },
      // 実行予算に含まれていない費目が実績にあるか確認し、あれば追加する。
      addNotExistsAchievementData() {
        for(let achievementRow of this.achievementTable) {
          // 工種名
          const name = achievementRow.report.tabName;
          for(let aggregate of this.aggregateList) {
            if(!achievementRow.report.expenseTableData[aggregate.name]) {
              continue;
            }
            for(let achievement of achievementRow.report.expenseTableData[aggregate.name]) {
              if(achievement.hasUsed) continue;

              for(let item of this.treeItems) {
                const isFind = this.findBudgetData(item, achievement, name);
                if(isFind) break;
              }
            }
          }
        }
      },
      // 追加する場所を実行予算から探して追加する
      findBudgetData(item, achievement, name) {
        if(item.text == name) {
          for(let aggregate of item.data.items) {
            if(achievement.id && achievement.id == aggregate.id) {
              aggregate.achievementPrice += achievement.price;
              aggregate.achievementAmount += parseInt(achievement.achievement);
              return true;
            } else if(achievement.expense == aggregate.expense) {
              aggregate.achievementPrice += achievement.price;
              aggregate.achievementAmount += parseInt(achievement.achievement);
              return true;
            }
          }

          const data = {
            id: achievement.id,
            no: item.data.items.length + 1,
            expense: achievement.expense,
            standard: achievement.standard,
            amount: 0,
            displayUnit: achievement.displayUnit,
            unitPrice: 0,
            price: 0,
            aggregateName: achievement.aggregateName,
            percentage_flg: achievement.percentage_flg,
            multipl: achievement.multiple,
            budgetPrice: 0,
            budgetAmount: 0,
            achievementPrice: achievement.price,
            achievementAmount: parseInt(achievement.achievement)
          };
          item.data.items.push(data);
          return true;
        }

        for(let child of item.children) {
          const isFind = this.findBudgetData(child, achievement, name);
          if(isFind) return true;
        }
        return false;
      }
    }
  }
</script>
